import React, { useEffect, useState } from "react";
import { Card, Table, Badge, Button, Form, Alert, Spinner } from "@themesberg/react-bootstrap";
import api from "../../utils/api";

const statusVariant = {
  active: "success",
  completed: "secondary",
  disabled: "danger"
};

export default () => {
  const [campaigns, setCampaigns] = useState([]);
  const [total, setTotal] = useState(0);
  const [status, setStatus] = useState("active");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = async () => {
    try {
      setLoading(true);
      const res = await api.get("/auto-msg/campaigns", {
        params: { status: status || undefined, limit: 100 }
      });
      setCampaigns(res.data?.campaigns || []);
      setTotal(res.data?.total || 0);
    } catch (e) {
      setError(e.response?.data?.error || e.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, [status]);

  const disable = async (userId) => {
    if (!window.confirm("Bu üyenin otomatik mesaj kampanyasını durdurmak istiyor musunuz?")) return;
    try {
      await api.post(`/auto-msg/campaigns/${userId}/disable`);
      await load();
    } catch (e) {
      setError(e.response?.data?.error || e.message);
    }
  };

  const fmt = (d) => {
    if (!d) return "—";
    try {
      return new Date(d).toLocaleString("tr-TR");
    } catch {
      return String(d);
    }
  };

  return (
    <div className="py-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <div>
          <h4 className="mb-1">Kampanya Durumu</h4>
          <p className="text-muted mb-0">Üye bazında otomatik mesaj akışı ({total} kayıt)</p>
        </div>
        <Form.Select style={{ width: 200 }} value={status} onChange={(e) => setStatus(e.target.value)}>
          <option value="active">Aktif</option>
          <option value="completed">Tamamlanan</option>
          <option value="disabled">Durdurulan</option>
          <option value="">Tümü</option>
        </Form.Select>
      </div>

      {error && <Alert variant="danger" dismissible onClose={() => setError(null)}>{error}</Alert>}

      <Card border="light" className="shadow-sm">
        <Card.Body className="p-0">
          {loading ? (
            <div className="d-flex justify-content-center py-5"><Spinner animation="border" /></div>
          ) : (
            <Table responsive hover className="align-middle mb-0">
              <thead>
                <tr>
                  <th>Üye</th>
                  <th>Durum</th>
                  <th>Aktif Fake</th>
                  <th>Adım</th>
                  <th>Sonraki Aksiyon</th>
                  <th>Zaman</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {campaigns.length === 0 && (
                  <tr><td colSpan={7} className="text-center text-muted py-4">Kayıt yok</td></tr>
                )}
                {campaigns.map((c) => {
                  const name = c.user?.displayName || c.user?.name || c.user?.firstName || c.userId;
                  return (
                    <tr key={c.id || c.userId}>
                      <td>
                        <div className="fw-bold">{name}</div>
                        <small className="text-muted">{c.user?.city || ""}</small>
                      </td>
                      <td>
                        <Badge bg={statusVariant[c.status] || "secondary"}>{c.status}</Badge>
                      </td>
                      <td className="text-truncate" style={{ maxWidth: 120 }}>
                        {c.currentFakeUid || "—"}
                      </td>
                      <td>{c.currentStepIndex >= 0 ? c.currentStepIndex + 1 : "—"}</td>
                      <td>
                        <Badge bg="info">{c.nextAction}</Badge>
                      </td>
                      <td>
                        <small>{fmt(c.nextActionAt)}</small>
                      </td>
                      <td className="text-end">
                        {c.status === "active" && (
                          <Button size="sm" variant="outline-danger" onClick={() => disable(c.userId)}>
                            Durdur
                          </Button>
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          )}
        </Card.Body>
      </Card>
    </div>
  );
};
